import React from "react";
import { Helmet } from "react-helmet-async";
import { match as Match } from "react-router-dom";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../utils";
import PageSubheader from "../../../../components/PageSubheader";
import PaymentMethodForm from "../form";

interface Props {
  match: Match<{ id: string }>;
  intl: IntlShape;
  backURL: string;
}

const UpdatePaymentMethod = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.payment.method.update.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-payment-method-update"
        goBackURL={backURL}
      />

      <PaymentMethodForm {...props} edition />
    </>
  );
};

export default withOneColLayout(injectIntl(UpdatePaymentMethod));
